import { View } from '@react-pdf/renderer';
import { styles } from '../PDFStyle';
import PDFTableHeader from './PDFTableHeader';

interface IPDFTableProps {
    columns: string[];
    data: string[][];
    checks?: (string | boolean) [][];
}

const PDFTable = (props: IPDFTableProps) => {
    return (
        <View>
            <View break style={[styles.row, styles.borderRow, styles.headerTable]}>
                <PDFTableHeader columns={props.columns} isHeader />
            </View>
            {props.data.map((data, index) => {
                let color = index % 2 == 0 ? '#dee0e1' : '#fff';
                let check = false;
                let checkColor = '#000';
                //check if data[0] is in one of checks  array if true check if checks[index][1] is true and set color to green or red
                if (props.checks) {
                    let checkIndex = props.checks.findIndex((check) => check[0] === data[0]);
                    if (checkIndex !== -1) {
                        check = true;
                        checkColor = props.checks[checkIndex][1] ? 'green' : 'red';
                    }
                }
                return (
                    <View style={[styles.row, styles.borderRow, { backgroundColor: color, color: checkColor, borderWidth: check ? '1px' : 0 , borderColor: checkColor }]} key={index}>
                        <PDFTableHeader columns={data} />
                    </View>
                );
            })}
        </View>
    );
};

export default PDFTable;
